var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Stack, Typography } from '@mui/material';
import { StatusPermission } from '../../enum';
import { useUserPermissionsAPI } from '../app/selectors';
import { useTerminologyTranslation } from '../app/terminology';
import { Autocomplete, FormField, NumberInput, renderGroupedOptions } from '../common';
import { useEffectivePlanPermission, useIsPlanLocked } from '../wizard/selectors';
export var TrainingRecruitmentForm = function (_a) {
  var _b, _c;
  var reportData = _a.reportData,
    queueData = _a.queueData,
    locationData = _a.locationData,
    _d = _a.disableButton,
    disableButton = _d === void 0 ? true : _d,
    control = _a.control,
    setCurrentScenario = _a.setCurrentScenario,
    setCurrentQueue = _a.setCurrentQueue,
    setCurrentQueueLocation = _a.setCurrentQueueLocation;
  var t = useTerminologyTranslation(['report', 'translation']).t;
  var recruitmentPermission = useUserPermissionsAPI().recruitmentPermission;
  var effectiveRecruitmentPermission = useEffectivePlanPermission(recruitmentPermission);
  var isPlanLocked = useIsPlanLocked();
  var disabled = effectiveRecruitmentPermission !== StatusPermission.Edit || isPlanLocked;
  var disabledLocationSelector = disabled || !(locationData === null || locationData === void 0 ? void 0 : locationData.length);
  return _jsxs(Stack, __assign({
    spacing: 4
  }, {
    children: [_jsx(Typography, __assign({
      variant: "h3"
    }, {
      children: t('training.enterTrainingDetails')
    })), _jsx(FormField, __assign({
      required: true,
      name: "scenarioId",
      label: t('training.chooseScenario'),
      control: control
    }, {
      children: _jsx(Autocomplete, {
        "data-testid": "select-scenario",
        options: reportData === null || reportData === void 0 ? void 0 : reportData.scenarios,
        getOptionLabel: function (o) {
          return o.isBaseline ? t('translation:baseline') : o.name;
        },
        onChange: setCurrentScenario
      })
    })), _jsx(FormField, __assign({
      required: true,
      name: "queueId",
      label: t('training.selectQueue'),
      control: control
    }, {
      children: _jsx(Autocomplete, {
        "data-testid": "select-queue",
        options: queueData,
        getOptionLabel: function (o) {
          return o.name;
        },
        groupBy: function (option) {
          var _a;
          return (_a = option.lobName) !== null && _a !== void 0 ? _a : '';
        },
        renderGroup: renderGroupedOptions,
        onChange: setCurrentQueue
      })
    })), _jsx(FormField, __assign({
      required: !!(locationData === null || locationData === void 0 ? void 0 : locationData.length),
      name: "queueLocationId",
      label: t('training.selectLocation', {
        defaultValue: 'Select Location'
      }),
      control: control
    }, {
      children: _jsx(Autocomplete, {
        disabled: disabledLocationSelector,
        "data-testid": "select-location",
        options: locationData !== null && locationData !== void 0 ? locationData : [],
        getOptionLabel: function (o) {
          return o.name;
        },
        onChange: setCurrentQueueLocation,
        placeholder: disabledLocationSelector ? t('translation:autocomplete.none') : t('translation:autocomplete.pleaseSelect')
      })
    })), _jsx(FormField, __assign({
      required: true,
      name: "trainingLength",
      label: t('training.trainingLengthHead'),
      unitLabel: (_b = t('translation:formFieldUnit.weeks')) === null || _b === void 0 ? void 0 : _b.toUpperCase(),
      control: control
    }, {
      children: _jsx(NumberInput, {
        min: 0,
        max: 24,
        disabled: disabled
      })
    })), _jsx(FormField, __assign({
      required: true,
      name: "forecastedGraduationRate",
      label: t('training.forecastedGraduationRateHead'),
      unitLabel: "%",
      control: control
    }, {
      children: _jsx(NumberInput, {
        min: 1,
        max: 100,
        decimal: 2,
        disabled: disabled
      })
    })), _jsx(FormField, __assign({
      required: true,
      name: "classSize",
      label: t('training.classSize'),
      control: control
    }, {
      children: _jsx(NumberInput, {
        min: 1,
        max: 10000,
        disabled: disabled
      })
    })), _jsx(FormField, __assign({
      required: true,
      name: "recruitingLeadTime",
      label: t('training.recruitingLeadTimeHead'),
      unitLabel: (_c = t('translation:formFieldUnit.weeks')) === null || _c === void 0 ? void 0 : _c.toUpperCase(),
      control: control
    }, {
      children: _jsx(NumberInput, {
        min: 1,
        max: 10000,
        disabled: disabled
      })
    })), _jsx(Button, __assign({
      style: {
        marginTop: '2rem'
      },
      variant: "contained",
      type: "submit",
      disabled: disableButton || disabled
    }, {
      children: t('translation:action.update')
    }))]
  }));
};